var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnThumbsUpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#24C062;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.2,8.1C15.1,8,15,7.9,14.9,7.8c-0.6-0.8-1.4-2.1-1.1-3.7c0.2-1.2-0.8-2-1.7-2.1c-1-0.1-2.1,0.4-2.7,1.6 C8.7,5,8.9,6.4,9.1,7.5C9.2,7.8,9.3,8,9.4,8.3H6.4c-1.7,0-3,1.6-2.7,3.3l1.2,6c0.3,1.3,1.4,2.2,2.7,2.2h7.8c0.3,0.6,0.9,1,1.6,1h2 c1,0,1.8-0.8,1.8-1.8V8c0-1-0.8-1.8-1.8-1.8h-2C16,6.2,15.2,7,15.2,8.1L15.2,8.1z M10.7,4.3c0.4-0.7,0.9-0.9,1.2-0.8 c0.4,0.1,0.4,0.3,0.4,0.4c-0.4,2.2,0.7,4,1.5,4.9c0.4,0.5,1,0.8,1.5,0.9v8.6H7.6c-0.6,0-1.1-0.4-1.2-1l-1.2-6 c-0.2-0.8,0.4-1.5,1.2-1.5h4.1c0.3,0,0.5-0.1,0.6-0.4c0.1-0.2,0.1-0.5,0-0.7l0,0l0,0c0,0,0,0,0-0.1c0-0.1-0.1-0.2-0.1-0.3 c-0.1-0.3-0.3-0.7-0.4-1.1C10.3,6.2,10.3,5.1,10.7,4.3z M16.8,8c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v11 c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2V8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnThumbsUpActive);
export default __webpack_public_path__ + "static/media/icn_thumbs-up-active.d83aa8260f1281940e399acead38a4e6.svg";
export { ForwardRef as ReactComponent };